module.exports = __webpack_public_path__ + "img/4_6_1.e11fb9d4.jpg";